import { Directive, HostListener, Input, inject } from '@angular/core';
import { TrackingEventType } from './config/tracking-map';
import { TrackingService } from './tracking.service';

@Directive({
  selector: '[appTracking]',
  standalone: true,
})
export class TrackingDirective {
  private trackingService = inject(TrackingService);

  @Input() appTracking!: TrackingEventType;

  @HostListener('click')
  onClick(): void {
    this.trackingService.pushEvent(this.appTracking);
  }
}
